import React from 'react';
import CustomGrid from 'components/controls/grid/CustomGrid';
import FacebookIcon from '../controls/icons/FacebookIcon';
import TwitterIcon from '../controls/icons/TwitterIcon';

export default function SocialLinks() {
    return (
        <CustomGrid
            container
            item
            spacing="xs"
        >
            <CustomGrid item>
                <a target='_blank' href='https://twitter.com/cirrusmed' >
                    <FacebookIcon />
                </a>
            </CustomGrid>
            <CustomGrid item>
                <a target='_blank' href='https://www.facebook.com/CirrusMed/' >
                    <TwitterIcon />
                </a>
            </CustomGrid>
        </CustomGrid>
    );
}



// WEBPACK FOOTER //
// ./src/components/Footer/SocialLinks.jsx